import { render, staticRenderFns } from "./StoreVoucher.vue?vue&type=template&id=5843f931"
import script from "./StoreVoucher.vue?vue&type=script&lang=js"
export * from "./StoreVoucher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports